<template>
	<div>
		<FunctionTitle :title="title" />
		<CommonFlame :title="pageTitle">
			<GanttChart
				:changeDatetimeFlag="false"
				:dialogName="dialogName"
				:categoryDialogLabel="categoryDialogLabel"
				:taskDialogLabel="taskDialogLabel"
				:categoryDialogHint="categoryDialogHint"
				:taskDialogHint="taskDialogHint"
				:categories="department_users"
				:tasks="requirements"
				:notDistributedTasks="not_distributed_requirements"
				:departmentName="departmentName"
				:departmentId="department_id"
				:dialogNoDataText="dialog_no_data_text"
				:categoryNameKey="categoryNameKey"
				:taskNameKey="taskNameKey"
				:startDateKey="startDateKey"
				:endDateKey="endDateKey"
				:isDraggable="authority"
				@update-task="updateResponder"
				@distribute-requirement="distributeRequirement"
				@show-task="showDialog"
			>
				<template v-slot:app-bar-btn>
					<div class="pa-3 d-flex">
						<v-btn class="ml-1 mr-10" color="secondary" @click="openDialog()"
							><v-icon>mdi-plus</v-icon>{{ dialogName }}</v-btn
						>
						<RequirementGanttChartHelpDialog
							:name="'requirementGanttChart'"
							:openBtnColor="'secondary'"
							:maxWidth="'850px'"
						/>
					</div>
				</template>
			</GanttChart>
			<RequirementShowDialog ref="show" />
			<AddTaskDialog
				ref="dialog"
				:dialogName="dialogName"
				:categoryDialogLabel="categoryDialogLabel"
				:taskDialogLabel="taskDialogLabel"
				:categoryDialogHint="categoryDialogHint"
				:taskDialogHint="taskDialogHint"
				:categories="department_users"
				:tasks="not_distributed_requirements"
				:departmentId="department_id"
				:dialogNoDataText="dialog_no_data_text"
				@send-value="distributeRequirement"
			/>
		</CommonFlame>
	</div>
</template>

<script>
import axios from "axios"
import authenticate from "../../helper/authenticate"
import errorHandling from "../../helper/errorHandling"
import GanttChart from "../shared/GanttChart.vue"
import RequirementShowDialog from "../requirement/components/RequirementShowDialog.vue"
import RequirementGanttChartHelpDialog from "../shared/HelpDialog.vue"
import AddTaskDialog from "../shared/AddTaskDialog"
import CommonFlame from "../shared/CommonFlame.vue"
import FunctionTitle from "../shared/FunctionTitle.vue"

export default {
	components: {
		GanttChart,
		RequirementShowDialog,
		RequirementGanttChartHelpDialog,
		AddTaskDialog,
		CommonFlame,
		FunctionTitle,
	},
	data() {
		return {
			pageTitle: "依頼担当者ガントチャート",
			title: "",
			dialogName: "担当未決定依頼振分",
			categoryDialogLabel: "部門内社員名を選択もしくは検索",
			taskDialogLabel: "依頼名を選択もしくは検索",
			categoryDialogHint: "依頼を振り分ける担当者を選択してください",
			taskDialogHint: "担当者に振り分ける依頼を選択してください",
			dialog_no_data_text: "担当者が決まっていない依頼はありません",
			department_users: [],
			departmentName: "",
			requirements: [],
			not_distributed_requirements: [],
			start_date: "",
			end_date: "",
			department_id: this.$route.params["id"],
			category_name: "",
			categoryNameKey: "name",
			taskNameKey: "name",
			startDateKey: "start_date",
			endDateKey: "end_date",
			authority: false,
		}
	},

	created() {
		this.fetchRequirements()
		authenticate.authenticateUser()
	},

	methods: {
		fetchRequirements() {
			const headers = authenticate.setHeader()
			axios
				.get(`/erp/v1/departments/${this.department_id}/requirement_users_ganttchart`, {
					headers,
				})
				.then((res) => {
					this.department_users = res.data.department_users.map(function (value) {
						value.collapsed = false
						value.name = value.full_name
						return value
					})
					this.departmentName = res.data.department.name

					// keyをpropsで送ってガントチャートで表示させる
					this.requirements = res.data.requirements.map(function (value) {
						value.name = value.requirement_type.name + (value.subtitle ? "：" + value.subtitle : "")
						value.start_date = value.requirement_date
						value.end_date = value.deadline
						value.category_id = value.responder_id
						return value
					})
					this.not_distributed_requirements = res.data.not_distributed_requirements
					this.authority = res.data.authority
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		updateResponder(requirement_id, responder_id) {
			const headers = authenticate.setHeader()
			axios
				.put(
					`/erp/v1/departments/${this.department_id}/requirement_users_ganttchart/${requirement_id}`,
					{
						requirement: { responder_id: responder_id },
					},
					{ headers }
				)
				.then((res) => {})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},

		distributeRequirement(responder, requirement) {
			const responder_id = responder.id
			const headers = authenticate.setHeader()

			axios
				.put(
					`/erp/v1/departments/${this.department_id}/requirement_users_ganttchart/${requirement.id}`,
					{ requirement: { responder_id } },
					{ headers }
				)
				.then((res) => {
					this.$store.commit("setFlash", {
						text: "追加しました",
						type: "notice",
					})

					requirement.category_id = res.data.responder_id
					requirement.name = res.data.name
					requirement.start_date = res.data.start_date
					requirement.end_date = res.data.end_date

					this.requirements.push(requirement)
					this.not_distributed_requirements = this.not_distributed_requirements.filter(function (
						v
					) {
						return v.id !== requirement.id
					})
					this.$refs.dialog.close()
				})
				.catch((err) => {
					let error = errorHandling.errorResponse(err)
					if (Array.isArray(error)) {
						this.errors = error
					}
				})
		},

		tranceJa(word) {
			return this.statusIdsHash[word]
		},

		showDialog(id, index) {
			this.$refs.show.openDialog(id, index)
		},
		openDialog() {
			this.$refs.dialog.open()
		},
	},
}
</script>
